<template>
  <page-wrapper background="/static/img/anniversary/page-contract/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
      22年间<br />您一共购买过<span class="text-highline">{{data.purchaseTimes}}</span>吉凯的产品或服务<br />合同金额总计<span class="text-highline">{{data.amount}}</span>
      <br /><br />
      双向奔赴的感觉真好！
      <br/>
      吉凯继续努力，提供定制化实验需求，
      <br/>
      让科研之路不再漫长
    </div>
    <img class="main-text-background ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-contract/shape1.png" />
    <img class="main-image-2 ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-contract/shape2.png" />
    <img class="main-image-3 ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-contract/shape3.png" />
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-text {
    position: absolute;
    left: 50%;
    bottom: 27.73333333vw;
    width: 73vw;
    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    margin-left: -35.8vw;
    letter-spacing: -0.3px;
    z-index: 99;

    /* 字体 */
    color: #193543;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }

    .text-notice {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .main-text-background {
    position: absolute;
    left: 50%;
    bottom: -15.2vw;
    width: 82.1vw;
    margin-left: -41.05vw;
    height: 121.8666667vw;
    z-index: 98;
  }

  .main-image-2 {
    position: absolute;
    right: 0vw;
    top: 5.6vw;
    width: 48.8vw;
    height: 78.13333333vw;
  }

  .main-image-3 {
    position: absolute;
    left: 0px;
    top: 5.6vw;
    width: 57.33333333vw;
    height: 62.4vw;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?57179744